enum ServiceCode {
    WaterBranchAssignment = '1-01',// verification by national code
    WasteWaterBranchAssignment = '1-02',//این انشعاب ثبت نشده.
    ReplyToInquiry = '2-01',//done
    ChangeAccountType = '2-02',//done
    ChangeSpecifications = '2-03',//done
    ChangeUnit = '2-04',//done
    ChangeCapacityContractualBranching = '2-05',//done
    ChangeBranchDiameter = '2-06',//done
    MeterSeparation = '2-07',//done
    MoveMeasuringDevices = '2-08',//done
    MeterTest = '2-09',//done
    MeterChange = '2-10',//done
    InstallAdditionalSiphon = '2-11',//done
    TemporaryDisconnectAndConnectBranch = '2-12',//done
    CollectOrMergeBranch = '2-13',//done
    MidTermBill = '2-14',//done
    BillingReview = '2-15',//done
    DeclareMeterConsumption = '2-16',//done
    SeeHistory = '2-17',//done
    BillingPayment = '2-18',//done
    Suggestions = '2-19',//done
    SaleTankerWater = '2-20',//done

}

export default ServiceCode